import data from "../../.sourceflow/content_tiles.json";
import CollectionHelper from "@/helpers/CollectionHelper";

class ContentCollectionHelper extends CollectionHelper {
  fetch({ category = null} = {}) {
    let items = this.collection.getItems();

    if (category) {
      items = items.filter((i) => {
        return i.category?.includes(category);
      });
    }

    return items;
  }
}

export const content_tiles_helper = new ContentCollectionHelper(data);
